var store = {
	namespaced: true,

	state: {
		currentBlock: null,
		selection: [],
		moving: false,

		focusTrigger: false,
		focusId: ''
	},

	getters: {
		currentBlock: function(state) {
			return state.currentBlock;
		},
		selection: function(state) {
			return state.selection;
		},
		moving: function(state) {
			return state.moving;
		},
		focusTrigger: function(state) {
			return state.focusTrigger;
		},
		focusId: function(state) {
			return state.focusId;
		}
	},

	mutations: {
		SET_CURRENT_BLOCK: function(state, block) {
			state.currentBlock = block;
		},
		SET_SELECTION: function(state, selection) {
			state.selection = selection;
		},
		UNSET_SELECTION: function(state) {
			state.selection = [];
		},
		SET_MOVING: function(state, moving) {
			state.moving = moving;
		},
		SET_FOCUS: function(state, blockId) {
			state.focusId = blockId;
			state.focusTrigger = !state.focusTrigger;
		}
	},

	actions: {
		async init(store) {},
		async setCurrentBlock(store, blockId) {
			if (blockId) {
				let block = store.rootGetters['block/block'](blockId);
				store.commit('SET_CURRENT_BLOCK', block);
			}
		},
		async setSelection(store, selection) {
			store.commit('SET_SELECTION', selection);
		},
		async unsetSelection(store) {
			store.commit('UNSET_SELECTION');
		},
		setFocus(store, blockId) {
			store.commit('SET_FOCUS', blockId);
		}
	}
};

export default store;
